export var HIGHEST_OI = "HIGHEST_OI";
export var HIGHEST_OI_STREAM = "HIGHEST_OI_STREAM";
